export type GroupedItem<T> = T & {
  borders?: {
    top: boolean;
    bottom: boolean;
    left: boolean;
    right: boolean;
  };
};

export const calculateBorders = <T>(
  elements: T[],
  elementsInRow: number,
  start: number,
): GroupedItem<T>[] => {
  if (elementsInRow === 1) {
    return elements.map((el, index) => {
      const borders = {
        top: index === 0,
        bottom: index === elements.length - 1,
        left: true,
        right: true,
      };
      return {
        ...el,
        borders,
      };
    });
  }

  if (elements.length === 1) {
    return elements.map((el) => ({
      ...el,
      borders: {
        top: true,
        bottom: true,
        left: true,
        right: true,
      },
    }));
  }

  return elements.map((el, index) => {
    const groupOrder = index + 1;

    const borders = {
      top: false,
      bottom: false,
      left: false,
      right: false,
    };

    if (
      (start + index) % elementsInRow === 0 &&
      (index + elementsInRow < elements.length ||
        index >= elementsInRow ||
        elements.length > elementsInRow)
    ) {
      borders.right = true;
    }

    if (
      (start + index) % elementsInRow === 1 &&
      (index + elementsInRow <= elements.length ||
        index >= elementsInRow ||
        elements.length > elementsInRow)
    ) {
      borders.left = true;
    }

    if (groupOrder - elementsInRow < 1) {
      borders.top = true;
    }

    if (groupOrder + elementsInRow > elements.length) {
      borders.bottom = true;
    }

    if (index === 0) {
      borders.top = true;
      borders.left = true;
    }

    if (index === elements.length - 1) {
      borders.right = true;
      borders.bottom = true;
    }

    return {
      ...el,
      borders,
    };
  });
};
